
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiAlarmSilencedIec as ObiAlarmSilencedIecElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-alarm-silenced-iec.js';
 
 
 

 
 export const ObiAlarmSilencedIec = createComponent({
   react: React,
   tagName: 'obi-alarm-silenced-iec',
   elementClass: ObiAlarmSilencedIecElement,
   events: {
     
   }
  });
 
 